import { Button, Drawer } from "@/components";
import { useEffect, useState } from "react";

import { ArrowLeftCircle, Kid } from "@/components/Icons";
import styles from "@/styles/containers/challenge-drawer.module.scss";
import classNames from "classnames/bind";
const css = classNames.bind(styles);

const createChallange = () => {
  const minOperand = 2;
  const maxOperand = 6;

  const createOperand = () => {
    return Math.floor(
      Math.random() * (maxOperand - minOperand + 1) + minOperand,
    );
  };

  const operandX = createOperand();
  const operandY = createOperand();

  const result = operandX * operandY;

  return {
    operandX,
    operandY,
    result,
  };
};

export function ChallengeDrawer({ onClose, onConfirm }) {
  const [value, setValue] = useState("");
  const [challange, setChallange] = useState({});
  const [step, setStep] = useState(1);

  useEffect(() => {
    const challange = createChallange();
    setChallange(challange);
  }, []);

  const onChangeValue = (v) => {
    if (value.length >= 2) return;

    setValue((prev) => prev + String(v));
  };

  const { operandX, operandY, result } = challange || {};

  const isValid = value == result;

  return (
    <Drawer
      open={true}
      alreadyDrawer
      direction="bottom-center"
      onClose={onClose}
    >
      {step === 1 && (
        <>
          <div className="d-flex align-center">
            <div className={styles.icon}>
              <Kid />
            </div>
            <div className="d-flex flex-col">
              <p className={styles.title}>Proteção infantil</p>
              <p className={styles.subtitle}>
                Por segurança, pedimos que resolva a multiplicação abaixo antes
                de enviar o seu pedido.
              </p>
            </div>
          </div>
          <Button
            className="mt-20 w-100"
            design="terciary"
            onClick={() => setStep(2)}
          >
            Continuar
          </Button>
        </>
      )}
      {step === 2 && (
        <>
          <div className="d-flex align-center gap-20">
            <div onClick={() => setStep(1)} className="d-flex align-center">
              <ArrowLeftCircle />
            </div>

            <div className={styles.challengeContainer}>
              <div>
                {operandX} x {operandY}
              </div>

              <div>&nbsp;=&nbsp;</div>

              <div className={styles.answer}>{value}</div>
            </div>

            <Button design="secondary-mini" onClick={() => setValue("")}>
              Limpar
            </Button>
          </div>

          <div className={styles.hairline} />

          <div className={styles.numbers}>
            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((number) => (
              <button
                key={number}
                className={css({
                  number: true,
                })}
                onClick={() => onChangeValue(number)}
              >
                {number}
              </button>
            ))}
          </div>

          <Button
            design="primary"
            disabled={!isValid}
            className="w-100"
            onClick={() => onConfirm()}
          >
            Prosseguir
          </Button>
        </>
      )}
    </Drawer>
  );
}
